import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";
import { paquetesBeneficios } from "../config/constants/paquetesBeneficios";
import deepmerge from "deepmerge";
import get from "lodash/get";
import { getValueByKey } from "../utils";
import { PCG7 } from "../config/constants";

const arrayMerge = (_, sourceArray) => sourceArray;
export default {
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
    if (payload.name === "consulta" && state.confirmarRenaper.yaValido) {
      state.confirmarRenaper.yaValido = false;
    }
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  [MUTATIONS.ON_FORZAR_DNE]: (state, payload) => {
    Vue.set(state, "forzarDNE", Object.assign({}, state.forzarDNE, payload));
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_OFFER]: (state, payload) => {
    let paquetes = get(payload, "oferta.paquetes[0]", false);

    Vue.set(state, "dataOferta", payload);
    if (paquetes) {
      Vue.set(state, "paquetesBeneficios", paquetesBeneficios(paquetes));
    }
  },
  [MUTATIONS.ON_PASO_1]: (state, payload) => {
    state.searchEncontesa.list = [];
    Vue.set(state, "paso1", payload);
    state.paso4.domicilioParticular = payload.domicilioParticular;
  },
  [MUTATIONS.ON_PASO_2]: (state, payload) => {
    Vue.set(state, "paso2", payload);
  },
  [MUTATIONS.ON_PASO_3]: (state, payload) => {
    Vue.set(state, "paso3", payload);
  },
  [MUTATIONS.ON_PASO_4]: (state, payload) => {
    state.searchEncontesa.list = [];
    Vue.set(state, "paso4", payload);
  },
  [MUTATIONS.onSelectEncotesaAlternativo]: (state, payload) => {
    state.paso4.searchEncontesa = false;
    state.searchEncontesa.list = [];
    let commitPayload = deepmerge.all([
      {},
      state.paso4,
      {
        otroDomicilio: {
          searchEncontesa: false,
          calle: payload.calleLocalidad,
          codigoPostal: payload.codigoPostal,
          valido: true
        }
      }
    ]);
    Vue.set(state, "paso4", commitPayload);
  },
  [MUTATIONS.onSelectEncotesaParticular]: (state, payload) => {
    let commitPayloadStep1 = deepmerge.all([
      {},
      state.paso1,
      {
        domicilioParticular: {
          searchEncontesa: false,
          calle: payload.calleLocalidad,
          codigoPostal: payload.codigoPostal,
          valido: true
        }
      }
    ]);
    Vue.set(state, "paso1", commitPayloadStep1);
    state.paso1.searchEncontesa = false;
    state.searchEncontesa.list = [];
  },
  [MUTATIONS.ON_MODIFICAR_DOMICILIO]: () => {},
  [MUTATIONS.ON_NORMALIZAR_DOMICILIO_ALTE]: (state, payload) => {
    state.paso4.otroDomicilio = payload;
  },
  [MUTATIONS.ON_NORMALIZAR_DOMICILIO_PART]: (state, payload) => {
    state.paso4.domicilioParticular = payload;
    state.paso1.domicilioParticular = payload;
  },
  [MUTATIONS.ON_OTRO_DOMICILIO]: () => {},
  [MUTATIONS.ON_SUCURSAL]: (state, payload) => {
    Vue.set(state, "sucursal", payload);
  },
  [MUTATIONS.ON_QUERY]: (state, payload) => {
    Vue.set(state, "dataQuery", payload);
  },
  [MUTATIONS.ON_GRACIAS]: (state, payload) => {
    state.dataOferta.oferta.valid = false;
    state.gracias.cbu = get(payload, "respuesta.cbu", null);
  },
  [MUTATIONS.ON_GRACIAS_CA]: (state, payload) => {
    state.dataOferta.oferta.valid = false;
    state.graciasCA.cbu = payload.respuesta.cbu;
  },
  [MUTATIONS.ON_GRACIAS_GTM]: () => {},
  [MUTATIONS.ON_SOLICITAR_TURNO]: () => {},
  [MUTATIONS.ON_SOCIAL_NET_STATUS]: (state, payload) => {
    state.socialNet.status = payload;
  },
  [MUTATIONS.ON_SEARCH_ENCOTESA]: (state, payload) => {
    state.searchEncontesa.list = payload;
  },
  [MUTATIONS.ON_CONFIRMAR_RENAPER]: (state, payload) => {
    state.confirmarRenaper = payload;
  },
  [MUTATIONS.ON_CONFIRMAR_RENAPER_FLAG]: (state, payload) => {
    state.confirmarRenaper.yaValido = payload;
  },
  [MUTATIONS.ON_INTERNAL_LINK]: () => {},
  [MUTATIONS.ON_INGRESO_BANCA_ONLINE]: () => {},
  [MUTATIONS.ADOBE_APP_STARTED]: (state, payload) => {
    state.trackClickElement = payload;
  },
  [MUTATIONS.ADOBE_APP_ON_CLICK_START]: (state, payload) => {
    state.trackOnClickStart = payload;
  },
  [MUTATIONS.ON_MOCK]: (state, payload) => {
    Vue.set(state, "mock", payload);
  },
  [MUTATIONS.ON_NOTIFICATION_TOAST]: (state, payload) => {
    Vue.set(state, "notificationToast", payload);
  },
  [MUTATIONS.ON_OPEN_MODAL]: (state, payload) => {
    state.openedModal = payload;
  },
  [MUTATIONS.onTCode]: (state, payload) => {
    state.tcode = payload;
  },
  [MUTATIONS.ON_DEVICEID]: (state, payload) => {
    state.deviceId = payload;
  },
  [MUTATIONS.ON_DEVICEIDTIMESTAMP]: (state, payload) => {
    state.deviceIdTimestamp = payload;
  },
  [MUTATIONS.ON_USER_TOKENIZADO]: (state, payload) => {
    state.userIdTokenizado = payload;
  },
  /**
   * Mutation que permite a Adobe Target inyectar en el store
   * el código de la actividad que debe seleccionarse
   * @uso (desde afuera): BBVA_TC.$store.dispatch('SET_ADOBE_TARGET_EXPERIENCE', 'AR062019_B')
   */
  [MUTATIONS.ON_ADOBE_TARGET_EXPERIENCE]: (state, payload) => {
    state.adobeTargetExperience = payload;
  },
  [MUTATIONS.ON_DOMICILIO]: (state, payload) => {
    // A veces la localidad no coincide con las localidades
    // en las constantes. Por seguridad para que el seleect
    // haga match en el value, pusheamos el valor de la localidad
    // recibida por la validación
    if (payload.localid) {
      if (!state.localidadesAgregadas[payload.codProv]) {
        Vue.set(state.localidadesAgregadas, payload.codProv, []);
      }
      state.localidadesAgregadas[payload.codProv].push({
        value: payload.localid.toUpperCase(),
        label: payload.localid.toUpperCase()
      });
    }
    payload.errores = [];

    // Mapeamos el nuevo campo domicilio
    // a los campos legacy de los pasos
    // datosPersonales, paso4 y configuracion
    const domicilioFormateado = {
      calle: getValueByKey(
        "codigoCampo",
        "0001",
        "valorCampo",
        payload.grilla,
        payload.desDomi
      ),
      numero: getValueByKey(
        "codigoCampo",
        "0007",
        "valorCampo",
        payload.grilla,
        ""
      ),
      piso: getValueByKey(
        "codigoCampo",
        "0009",
        "valorCampo",
        payload.grilla,
        ""
      ),
      dpto: getValueByKey(
        "codigoCampo",
        "0010",
        "valorCampo",
        payload.grilla,
        ""
      ),
      codigoPostal: payload.codPost,
      localidad: payload.localid,
      provincia: payload.codProv,
      valido: true
    };

    // Si ya tengo un domicilio cargado, lo cargo como preexistente
    // para poder determinar si es MODIFICAR o ALTA
    // el campo validarPreexistente se usa en las invocaciones a las mutations
    // resultados de una consulta o un alta exitosa
    if (
      payload.validarPreexistente &&
      payload.codPais &&
      payload.codPost &&
      payload.localid &&
      payload.desDomi
    ) {
      domicilioFormateado.preexistente = true;
      payload.preexistente = true;
    }
    delete payload.validarPreexistente;

    // Lote y casa en 000 desde la trx
    payload.lote = payload.lote === "000" ? "" : payload.lote;
    payload.casa = payload.casa === "000" ? "" : payload.casa;

    // Guardo el domicilio
    if (payload.tDomic === PCG7.TDOMIC.CORRESPONDENCIA) {
      // DOMICILIO ALTERNATIVO
      state.domicilioAlternativo = deepmerge(
        state.domicilioAlternativo,
        payload,
        { arrayMerge }
      );
      state.identidad.otroDomicilio = deepmerge({}, domicilioFormateado);
      state.configuracion.otroDomicilio = deepmerge({}, domicilioFormateado);
    } else {
      // DOMICILIO PARTICULAR
      state.domicilio = deepmerge(state.domicilio, payload, {
        arrayMerge
      });
      state.datosPersonales.domicilioParticular = deepmerge(
        {},
        domicilioFormateado
      );
      state.identidad.domicilioParticular = deepmerge({}, domicilioFormateado);
      state.configuracion.domicilioParticular = deepmerge(
        {},
        domicilioFormateado
      );
    }
  },
  [MUTATIONS.ON_CONSULTA]: (state, payload) => {
    state.contratacionFinalizada = false;
    state.consulta = { ...state.consulta, ...payload };
    state.consulta.completed = true;
    // Volvemos el elemento clickeado a null para volver a disparar app started
    state.trackClickElement = null;
    /*// Seteo email por defecto para resumen digital
      state.paso4.resumenDigitalEmail =
        state.paso4.resumenDigitalEmail !== ""
          ? state.paso4.resumenDigitalEmail
          : payload.email;*/
  },
  [MUTATIONS.ON_OFERTA]: (
    state,
    { oferta, tarjetaVos, tipoSolicitud, nroDeTramite }
  ) => {
    const ofertaCompleta = {
      ...oferta,
      tarjetaVos,
      tipoSolicitud
    };
    state.oferta = ofertaCompleta;
    state.dataOferta.oferta = ofertaCompleta;
    state.dataOferta.nroDeTramite = nroDeTramite;
  },
  [MUTATIONS.ON_DATOS_PERSONALES]: (state, payload) => {
    const datosPersonales = deepmerge({}, payload);
    state.datosPersonales = datosPersonales;
    state.pageLoading = false;
    state.configuracion.domicilioParticular =
      datosPersonales.domicilioParticular;
  },
  [MUTATIONS.ON_VALIDANDO_DOMICILIO]: (state, payload) => {
    // Necesario para tener un flag para saber
    // el inicio y el fin de la validación/carga
    // de domicilio
    state.validandoDomicilio = Boolean(payload);
    if (!payload) {
      Vue.set(state, "isLoading", payload);
    }
  },
  [MUTATIONS.ON_SUCURSALES]: (state, payload) => {
    state.sucursales = payload;
  },
  [MUTATIONS.ON_DATOS_LABORALES]: (state, payload) => {
    state.datosLaborales = payload;
  },
  [MUTATIONS.ON_INFORMACION_ADICIONAL]: (state, payload) => {
    state.informacionAdicional = payload;
    if (payload.sujetoObligado === "0") {
      state.informacionAdicional.actividadSujetoObligado = "";
    }
  },
  [MUTATIONS.ON_THANKS_VERIDAS]: (state, payload) => {
    state.dataVeridas.thanksVeridas = payload;
  },
  [MUTATIONS.ON_DIGITAL_PRESENCIAL]: (state, payload) => {
    state.identidad = payload;
  },
  [MUTATIONS.ON_RESULT_VERIDAS]: (state, payload) => {
    state.dataVeridas.response = payload;
  },
  [MUTATIONS.ON_PRELOAD_SDK]: (state, payload) => {
    Vue.set(state.sdk, "preload", payload);
  },
  [MUTATIONS.ON_SAVE_IFRAME]: (state, payload) => {
    Vue.set(state.sdk, "iframe", payload);
  },
  [MUTATIONS.SET_DVS_IFRAME_DATA]: (state, payload) => {
    Vue.set(state, "DVSIframeData", payload);
  },
  [MUTATIONS.RESET_DVS_IFRAME_DATA]: state => {
    Vue.set(state, "DVSIframeData", {
      urlXpressId: "",
      id: ""
    });
  },
  [MUTATIONS.ON_ERROR_VERIDAS]: (state, payload) => {
    // No reemplazar el error si ya existe y estoy enviando uno nuevo
    // Si reemplazar si estoy reseteando el error
    if ((!state.errorVeridas && payload) || payload === "") {
      state.errorVeridas = payload;
    }
  },
  [MUTATIONS.ON_ERROR]: (state, payload) => {
    state.error = payload;
  },
  [MUTATIONS.ON_DATA_AUTH_ASO]: (state, payload) => {
    Vue.set(state, "dataAuthASO", payload);
  },
  [MUTATIONS.ON_CLICK_CTA]: () => {
    // El px runner escucha este evento
    // no es necesario mutar state
  },
  [MUTATIONS.ON_VERIDAS_EVENT]: () => {
    // GTM escucha este evento
    // no es necesario mutar state
  },
  [MUTATIONS.ON_IS_VISIBLE_SDK]: (state, payload) => {
    Vue.set(state.sdk, "isVisible", payload);
  },
  [MUTATIONS.ON_FUNNEL_ERROR]: (state, payload) => {
    // Acá queremos guardar el error al state pero no queremos
    // Que el usuario vuelva a completar la consulta
    state.error = payload;
  },
  [MUTATIONS.ON_LOGIN]: (state, payload) => {
    state.dataVeridas.key = payload.key;
  },
  [MUTATIONS.ON_BIOMETRIA_POSITIVO]: (state, payload) => {
    state.dataVeridas.response = payload;
  },
  [MUTATIONS.ON_CONFIGURACION]: (state, payload) => {
    state.configuracion = payload;
  },
  [MUTATIONS.ON_CONTRATACION]: (state, payload) => {
    Vue.set(state, "respuestaContratacion", payload);
    Vue.set(state, "contratacionFinalizada", true);
  },
  [MUTATIONS.ON_CONSULTA_CONTRATO]: (state, payload) => {
    state.dataVeridas.contracts = payload;
  },
  [MUTATIONS.ON_CONTRATO]: (state, payload) => {
    state.contrato = payload;
  },
  [MUTATIONS.ON_FIRMA_CONTRATOS]: state => {
    state.contrato.firmaContrato = true;
  },
  [MUTATIONS.ON_SEGMENTO_SCORE_CLIENTE]: (state, payload) => {
    Vue.set(state.consulta, "segmentoScoreCliente", payload);
  },
  [MUTATIONS.ON_CUENTA]: (state, payload) => {
    Vue.set(state, "cuenta", payload);
  },
  [MUTATIONS.ON_NORMALIZAR_CELULAR]: (state, payload) => {
    state.consulta.celular.normalizado = {
      ...state.consulta.celular.normalizado,
      ...payload
    };
  },
  [MUTATIONS.ON_CELULAR]: (state, payload) => {
    state.celular = payload;
  },
  [MUTATIONS.ON_OTP_ERROR]: state => {
    Vue.set(state.celular, "error", true);
  },
  [MUTATIONS.ON_OTP_ONE]: (state, payload) => {
    state.celular.primerosDigitos = payload.otp;
    state.celular.deviceUdid = payload.deviceUdid;
    state.celular.error = false;
  },
  [MUTATIONS.ON_USUARIO_CLAVE]: (state, payload) => {
    state.usuarioClave = payload;
  },
  [MUTATIONS.ON_HUELLA_AVANZADA]: () => {}
};
